
















































































































































































import { Component, Emit, Vue } from 'vue-property-decorator'
import { Auth } from '@finx/web-repository/src/services/Oidc'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'
import SolicitacaoPendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'
import SolicitacaoCancelamentoStore from '@/components/SolicitacaoCancelamento/Store/SolicitacaoCancelamentoStore'
import ContestacaoMedicaStore from '@/components/ContestacaoMedica/Store/ContestacaoMedicaStore'
import { TipoUsuarioEnum, Snackbar, RequestMessage as MSG, TipoOrigemEnum, CancelarSolicitacaoParam } from '@/types/_'
import Theme from '@/styles/Theme'
import moment from 'moment'
import { instrumentador } from '@/utils/common'

@Component
export default class ComponentModalSolicitacaoCirurgiaItensAutorizados extends Vue {
  closeButton: boolean = false
  closeAutorz: boolean = false

  get closeBtn() {
    return this.closeButton
  }

  set closeBtn(value: boolean) {
    this.closeButton = value
  }

  get closeAutorizar() {
    return this.closeAutorz
  }

  set closeAutorizar(value: boolean) {
    this.closeAutorz = value
  }

  get filterCirurgias() {
    return this.getSolicitacaoStore.filterCirurgias
  }

  snackbar: Snackbar = {
    disabled: false,
    disabledBtn: false,
    show: false,
    timeout: 12000,
    message: '',
  }

  tipoUsuario: string = TipoUsuarioEnum.Medico
  confirm: boolean = false
  confirmar: boolean = false
  disable: boolean = true

  get getSolicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  get getSolicitacaoPendenciaStore() {
    return getModule(SolicitacaoPendenciaStore, this.$store)
  }

  get getContestacaoMedicaStore() {
    return getModule(ContestacaoMedicaStore, this.$store)
  }

  get getSolicitacaoCancelamentoStore() {
    return getModule(SolicitacaoCancelamentoStore, this.$store)
  }

  get showModalItensAutorizados() {
    return this.getSolicitacaoStore.modalSolicitacaoCirurgia.showItensAutorizados
  }

  set showModalItensAutorizados(value: boolean) {
    this.getSolicitacaoStore.setShowModalItensAutorizados(value)
  }

  formatDate(value: string) {
    return moment(value).format('DD/MM/YYYY')
  }

  async closeModal() {
    this.closeBtn = true
    this.refreshSolicitacao()
    this.showModalItensAutorizados = false
    this.closeBtn = false
  }

  @Emit('refreshSolicitacao')
  refreshSolicitacao() {}

  async getUser() {
    return this.$user
  }

  get getTheme() {
    return Theme
  }

  checkStatus(value) {
    if (value && value.key) {
      return ['AutorizadaParcial', 'Autorizada', 'Cancelada', 'CancelamentoSolicitado'].includes(value.key)
    }
    return false
  }

  checkCancelBtn(value) {
    return ['Autorizada', 'Cancelada', 'CancelamentoSolicitado'].includes(value)
  }

  async autorizar() {
    // this.setLoadingRequest(true, this.getSolicitacaoStore.requestMessage.update)
    this.closeAutorizar = true
    const response = await this.getSolicitacaoStore.autorizacaoParcial(this.getSolicitacaoStore.solicitacao.id)
    if (response.success) {
      await this.getSolicitacaoPendenciaStore.setAgendamentoMedico(response.data.solicitacao)
      this.disable = !this.disable
      this.confirmar = false
    } else {
      this.snackBarMessageError('Houve um problema na autorização da solicitação.')
    }
    this.closeAutorizar = false
    // this.clearLoadingRequest()
  }

  cancelamento() {
    const cancelarSolicitacaoParam: CancelarSolicitacaoParam = {
      solicitacaoId: this.getSolicitacaoPendenciaStore.pendencia.solicitacaoId,
      tipoOrigem: TipoOrigemEnum.Undefined,
      canceladoMotivo: {
        display: '',
        key: '',
      },
      situacao: {
        display: '',
        key: '',
      },
      modal: '',
    }

    this.getSolicitacaoCancelamentoStore.setCancelarSolicitacaoParam(cancelarSolicitacaoParam)
    this.getSolicitacaoCancelamentoStore.setShowModalCancelamentoMedico(true)
  }

  snackBarMessageError(message) {
    this.snackbar.message = message
    this.snackbar.show = true
    this.getSolicitacaoStore.setSnackbar(this.snackbar)
  }

  async contestar() {
    this.setLoadingRequest(true, this.getSolicitacaoStore.requestMessage.avancar.text)
    const request = await this.getContestacaoMedicaStore.getContestacaoMedica(this.getSolicitacaoStore.solicitacao.id)
    if (request.success) {
      this.getContestacaoMedicaStore.setShowModalContestacaoMedica(true)
    } else {
      this.snackBarMessageError('Houve um problema ao abrir/verificar contestação.')
    }
    this.clearLoadingRequest()
  }

  @Emit('setLoadingRequest')
  setLoadingRequest(status, text) { }

  @Emit('clearLoadingRequest')
  clearLoadingRequest() { }
}
